import graphql__04f9f9d510c6291b7dc3 from "./__generated__/EmailLayoutViewQuery.graphql.ts";
import graphql__4511f820292316982566 from "./__generated__/EmailLayoutViewRenameMutation.graphql.ts";import * as React from "react";
import {useState, useCallback} from "react";
import {graphql, useMutation} from "react-relay";
import {Outlet, useParams} from "react-router";
import {connect, ConnectedProps} from "react-redux";
import {hideModal, showModal} from "../store/actions";
import BreadcrumbNavigation from "./navigation/BreadcrumbNavigation";
import {loadQuery, usePreloadedQuery} from "react-relay/hooks";
import EmailLayoutViewQuery, {EmailLayoutViewQuery as EmailLayoutViewQueryType} from "./__generated__/EmailLayoutViewQuery.graphql";
import {useIntl} from "react-intl";
import MarketingHeader from "./presentational/MarketingHeader";

type EmailLayoutViewParams = {
    prepared: any
};

const connector = connect(undefined, {
    dispatchShowModal: showModal,
    dispatchHideModal: hideModal
});

type EmailLayoutViewProps = EmailLayoutViewParams & ConnectedProps<typeof connector>;

const EmailLayoutView: React.FC<EmailLayoutViewProps> = (props) => {
    const intl = useIntl();
    const params = useParams();
    const [isSaving, setIsSaving] = useState(false);

    const data = usePreloadedQuery<EmailLayoutViewQueryType>(
        graphql__04f9f9d510c6291b7dc3,
        props.prepared.emailLayoutViewQuery,
    );

    const [commitRenameMutation] = useMutation(graphql__4511f820292316982566);

    const handleTitleEdit = useCallback((newTitle: string) => {
        if (!data.node) return;
        setIsSaving(true);
        commitRenameMutation({
            variables: {
                input: {
                    id: data.node.emailLayoutIdentifier,
                    name: newTitle,
                }
            },
            onCompleted: () => {
                setIsSaving(false);
            },
            onError: () => {
                setIsSaving(false);
            },
        });
    }, [data.node, commitRenameMutation]);

    if (!data.node) {
        return (
            <div className="text-center py-12">
                <p className="text-gray-500">{intl.formatMessage({id: 'view.emailLayout.notFound'})}</p>
            </div>
        );
    }

    const emailLayout = data.node;

    // Badge for default status
    const defaultBadge = emailLayout.isDefault ? {
        value: 'DEFAULT',
        label: intl.formatMessage({id: 'emailLayout.badge.default'}),
        states: {
            yellow: ['DEFAULT'],
        },
    } : undefined;

    const breadcrumbNavigationItems = [
        {label: intl.formatMessage({id: 'breadcrumb.marketing'}), to: '/marketing'},
        {label: intl.formatMessage({id: 'breadcrumb.layouts'}), to: '/marketing/layouts'},
        {label: emailLayout.name ?? '', to: `/marketing/layouts/${params.id}`}
    ];

    return (
        <>
            <BreadcrumbNavigation items={breadcrumbNavigationItems}/>
            <MarketingHeader
                type="emailLayout"
                title={emailLayout.name ?? ''}
                identifier={emailLayout.emailLayoutIdentifier}
                badge={defaultBadge}
                onTitleEdit={handleTitleEdit}
                isSaving={isSaving}
            />
            <div className="mx-auto lg:px-8 grid grid-cols-1 gap-x-4 gap-y-8">
                <Outlet context={{...props.prepared, emailLayout}}/>
            </div>
        </>
    );
}

export default connector(EmailLayoutView);

function prepare_EmailLayoutView(params, relayEnvironment) {
    return {
        emailLayoutViewQuery: loadQuery(
            relayEnvironment,
            EmailLayoutViewQuery,
            {id: params.id},
            {fetchPolicy: 'store-and-network'},
        ),
    }
}

export {prepare_EmailLayoutView};
